import { scheduleIdle } from './loadExternalScript';

const GA_MEASUREMENT_ID = 'G-GNSQ86JE2C';

const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined' || window.__gtagLoaded) return;
  window.__gtagLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

const loadFacebookPixel = () => {
  if (typeof window === 'undefined' || window.fbq) return;

  const fbq = function () {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments);
    } else {
      fbq.queue.push(arguments);
    }
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  fbq('init', '601643682557384');
  fbq('track', 'PageView');
};

const loadLinkedInInsight = () => {
  if (typeof window === 'undefined' || window.lintrk) return;

  window._linkedin_partner_id = '8435820';
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push('8435820');
  window._linkedin_data_partner_ids.push('9140257');
  window._linkedin_data_partner_ids.push('10147257');

  window.lintrk = function (a, b) {
    window.lintrk.q.push([a, b]);
  };
  window.lintrk.q = [];

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};

export const deferThirdPartyTracking = () => {
  if (typeof window === 'undefined' || window.__thirdPartyTrackingDeferred) return;
  window.__thirdPartyTrackingDeferred = true;

  scheduleIdle(() => {
    loadGoogleAnalytics();
    loadFacebookPixel();
    loadLinkedInInsight();
  });
};
